import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function TestEmail() {
  const [testResult, setTestResult] = useState('');
  const [loading, setLoading] = useState(false);

  const testEmailConfig = async () => {
    setLoading(true);
    setTestResult('Testing email configuration...');
    
    try {
      // Import Firebase Functions
      const { getFunctions, httpsCallable } = await import('firebase/functions');
      const functions = getFunctions();
      
      console.log('Testing email configuration...');
      const testConfig = httpsCallable(functions, 'testEmailConfig');
      const result = await testConfig();
      
      console.log('Test result:', result);
      
      if (result.data.success) {
        setTestResult(`✅ Email configuration test passed: ${result.data.message}`);
      } else {
        setTestResult(`❌ Email configuration test failed: ${result.data.error}`);
      }
    } catch (error) {
      console.error('Test error:', error);
      setTestResult(`❌ Test error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const testFunctionAccess = async () => {
    setLoading(true);
    setTestResult('Testing function accessibility...');
    
    try {
      // Import Firebase Functions
      const { getFunctions, httpsCallable } = await import('firebase/functions');
      const functions = getFunctions();
      
      console.log('Testing function accessibility...');
      
      // Test the simple access function
      const testAccess = httpsCallable(functions, 'testFunctionAccess');
      console.log('testFunctionAccess callable created');
      
      const result = await testAccess({ test: true });
      console.log('Access test result:', result);
      
      if (result.data.success) {
        setTestResult(`✅ Function access test passed: ${result.data.message}`);
      } else {
        setTestResult(`❌ Function access test failed: ${result.data.error}`);
      }
    } catch (error) {
      console.error('Function access error:', error);
      setTestResult(`❌ Function access error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const testCORS = async () => {
    setLoading(true);
    setTestResult('Testing CORS configuration...');
    
    try {
      // Import Firebase Functions
      const { getFunctions, httpsCallable } = await import('firebase/functions');
      const functions = getFunctions();
      
      console.log('Testing CORS configuration...');
      
      // Test the CORS function
      const testCors = httpsCallable(functions, 'testCORS');
      console.log('testCORS callable created');
      
      const result = await testCors({ test: true });
      console.log('CORS test result:', result);
      
      if (result.data.success) {
        setTestResult(`✅ CORS test passed: ${result.data.message}`);
      } else {
        setTestResult(`❌ CORS test failed: ${result.data.error}`);
      }
    } catch (error) {
      console.error('CORS test error:', error);
      setTestResult(`❌ CORS test error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const testWelcomeEmail = async () => {
    setLoading(true);
    setTestResult('Testing welcome email...');
    
    try {
      // Import Firebase Functions
      const { getFunctions, httpsCallable } = await import('firebase/functions');
      const functions = getFunctions();
      
      console.log('Testing welcome email...');
      const sendEmail = httpsCallable(functions, 'sendWelcomeEmail');
      const result = await sendEmail({
        email: 'test@example.com',
        username: 'TestUser',
        role: 'user'
      });
      
      console.log('Email test result:', result);
      
      if (result.data.success) {
        setTestResult(`✅ Welcome email test passed: ${result.data.message}`);
      } else {
        setTestResult(`❌ Welcome email test failed: ${result.data.error}`);
      }
    } catch (error) {
      console.error('Email test error:', error);
      setTestResult(`❌ Email test error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container">
      <header className="page-header">
        <h1>Email Function Testing</h1>
      </header>
      
      <main className="page-content">
        <div className="test-section">
          <h2>Test Email Configuration</h2>
          <p>This will test if the Gmail authentication is working properly.</p>
          <button 
            onClick={testEmailConfig} 
            disabled={loading}
            className="dashboard-button"
          >
            {loading ? 'Testing...' : 'Test Email Config'}
          </button>
        </div>
        
        <div className="test-section">
          <h2>Test Function Accessibility</h2>
          <p>This will test if the sendWelcomeEmail function can be accessed.</p>
          <button 
            onClick={testFunctionAccess} 
            disabled={loading}
            className="dashboard-button"
          >
            {loading ? 'Testing...' : 'Test Function Access'}
          </button>
        </div>
        
        <div className="test-section">
          <h2>Test CORS Configuration</h2>
          <p>This will test if CORS is properly configured.</p>
          <button 
            onClick={testCORS} 
            disabled={loading}
            className="dashboard-button"
          >
            {loading ? 'Testing...' : 'Test CORS'}
          </button>
        </div>
        
        <div className="test-section">
          <h2>Test Welcome Email</h2>
          <p>This will test sending a welcome email to a test address.</p>
          <button 
            onClick={testWelcomeEmail} 
            disabled={loading}
            className="dashboard-button"
          >
            {loading ? 'Testing...' : 'Test Welcome Email'}
          </button>
        </div>
        
        <div className="test-result">
          <h3>Test Result:</h3>
          <div className="result-display">
            {testResult || 'No tests run yet'}
          </div>
        </div>
        
        <div className="test-info">
          <h3>What These Tests Do:</h3>
          <ul>
            <li><strong>Test Email Config:</strong> Verifies Gmail authentication and connection</li>
            <li><strong>Test Welcome Email:</strong> Attempts to send a welcome email</li>
          </ul>
          <p><strong>Note:</strong> Check the browser console for detailed logs.</p>
        </div>
      </main>
    </div>
  );
}
